import { render, staticRenderFns } from "./ProjectPortrait.vue?vue&type=template&id=71af1f5d&scoped=true&"
import script from "./ProjectPortrait.vue?vue&type=script&lang=js&"
export * from "./ProjectPortrait.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPortrait.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProjectPortrait.vue?vue&type=style&index=1&id=71af1f5d&lang=scss&scoped=true&"
import style2 from "./ProjectPortrait.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71af1f5d",
  null
  
)

export default component.exports